import React from 'react';
import { motion } from 'framer-motion';
import { SparklesIcon, ClockIcon } from 'lucide-react';
export function PriceBox() {
  return <section className="py-12 md:py-16 px-4 bg-bg-primary" data-id="element-202">
      <div className="max-w-3xl mx-auto" data-id="element-203">
        <motion.div className="relative rounded-3xl p-8 md:p-12 text-center text-white shadow-2xl overflow-hidden" style={{
        background: 'linear-gradient(135deg, #D6217A 0%, #E91E8C 50%, #FF3DA0 100%)'
      }} initial={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} whileInView={{
        opacity: 1,
        scale: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-204">
          {/* Decorative glow */}
          <div className="absolute -top-16 -right-16 w-48 h-48 bg-white/20 rounded-full blur-3xl pointer-events-none" data-id="element-205"></div>
          <div className="absolute -bottom-16 -left-16 w-48 h-48 bg-white/10 rounded-full blur-3xl pointer-events-none" data-id="element-206"></div>

          <div className="relative z-10" data-id="element-207">
            <div className="inline-flex items-center gap-2 bg-white/20 backdrop-blur-sm px-4 py-2 rounded-full mb-6" data-id="element-208">
              <SparklesIcon className="w-4 h-4" data-id="element-209" />
              <span className="text-sm font-semibold uppercase tracking-wide" data-id="element-210">
                Oferta de lanzamiento
              </span>
            </div>

            <h2 className="font-heading text-3xl md:text-4xl font-bold mb-6" data-id="element-211">
              Precio especial de promoción
            </h2>

            <div className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-8 mb-6" data-id="element-212">
              <div className="flex flex-col items-center" data-id="element-213">
                <span className="text-sm uppercase tracking-wider opacity-80 mb-1" data-id="element-214">
                  Antes
                </span>
                <span className="text-3xl md:text-4xl font-bold line-through opacity-70" data-id="element-215">
                  $15,99
                </span>
              </div>

              <div className="hidden sm:block w-px h-16 bg-white/40" data-id="element-216"></div>

              <div className="flex flex-col items-center" data-id="element-217">
                <span className="text-sm uppercase tracking-wider opacity-90 mb-1" data-id="element-218">
                  Ahora
                </span>
                <span className="font-heading text-5xl md:text-7xl font-extrabold leading-none" data-id="element-219">
                  $11,99
                </span>
              </div>
            </div>

            <div className="inline-flex items-center gap-2 bg-white text-[#D6217A] px-5 py-2.5 rounded-full font-bold text-sm md:text-base shadow-lg" data-id="element-220">
              <ClockIcon className="w-4 h-4" data-id="element-221" />
              Solo por esta semana
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}